import React from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import { FaBell, FaTag, FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { formatReleaseTitle, parseReleaseDescription } from "../../utils/releaseNotesFormatter";

function ReleaseNotesModal({ release, onClose }) {
    const navigate = useNavigate();

    if (!release) return null;

    const parsed = parseReleaseDescription(release.description);
    const displayTitle = formatReleaseTitle(release);

    const handleVerMas = () => {
        onClose();
        navigate("/novedades");
    };

    return (
        <Modal show centered onHide={onClose} size="lg">
            <Modal.Header className="border-0 pb-0 pt-4 px-4">
                <div className="d-flex align-items-center gap-3 w-100">
                    <div className="p-2 bg-primary bg-opacity-10 rounded-circle">
                        <FaBell size={20} className="text-primary" />
                    </div>
                    <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                            <Modal.Title className="fw-bold mb-0">{displayTitle}</Modal.Title>
                            {release.version && (
                                <Badge bg="primary" className="rounded-pill d-flex align-items-center gap-1">
                                    <FaTag size={10} />
                                    {release.version}
                                </Badge>
                            )}
                        </div>
                        {release.upload_date && (
                            <div className="d-flex align-items-center gap-1 text-muted small mt-1">
                                <FaCalendarAlt size={11} />
                                <span>
                                    {new Date(release.release_date || release.upload_date).toLocaleDateString("es-ES", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    })}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
                {parsed.sections.length > 0 || parsed.notes.length > 0 ? (
                    <div className="text-secondary">
                        {parsed.sections.map((section) => (
                            <div key={section.key} className="mb-3">
                                <p className="fw-semibold mb-2">{section.title}</p>
                                <ul className="mb-0" style={{ paddingLeft: "1.1rem" }}>
                                    {section.items.map((item, idx) => (
                                        <li key={`${section.key}-${idx}-${item}`} className="mb-1" style={{ lineHeight: "1.6" }}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                        {parsed.notes.length > 0 && (
                            <div className="small text-muted" style={{ lineHeight: "1.6" }}>
                                {parsed.notes.join(" ")}
                            </div>
                        )}
                    </div>
                ) : (
                    <p className="text-muted">Sin descripción disponible.</p>
                )}
            </Modal.Body>

            <Modal.Footer className="border-0 px-4 pb-4 gap-2">
                <Button variant="outline-secondary" onClick={handleVerMas}>
                    Ver historial completo
                </Button>
                {parsed.fullChangelogUrl && (
                    <Button
                        as="a"
                        href={parsed.fullChangelogUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="outline-primary"
                    >
                        Changelog técnico
                    </Button>
                )}
                <Button variant="primary" onClick={onClose}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReleaseNotesModal;
